// src/components/flyer/PublicFlyerA4.jsx
import React from "react";
import AdvertSlotCardPrint from "./AdvertSlotCardPrint";

function partitionSlots(slots) {
  return {
    left: slots.slice(0, 16),
    right: slots.slice(16, 32),
  };
}

function Grid16({ slots }) {
  const cells = [];

  for (let i = 0; i < 16; i++) {
    cells.push(slots[i] || null);
  }

  return (
    <div
      className="page-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 278px)",   // max width
        gridTemplateRows: "repeat(4, 192px)",      // frozen height
        gap: "4px",                                // ⭐ spacing (no margins)
        width: "1112px",                           // 278 × 4
        height: "784px",                           // ⭐ 196 × 4
        margin: "0 auto",
        boxSizing: "border-box",
      }}
    >
      {cells.map((slot, idx) => (
        <div
          key={slot?.id || idx}
          style={{
            width: "278px",
            height: "192px",
            // ⭐ NO MARGIN HERE
          }}
        >
          <AdvertSlotCardPrint slot={slot} />
        </div>
      ))}
    </div>
  );
}

export default function PublicFlyerA4({ sector, slots = [] }) {
  if (!sector) return null;

  const { left, right } = partitionSlots(slots);

  return (
    <div id="print-root">
      <div className="page">
        <Grid16 slots={left} />
      </div>

      <div className="page">
        <Grid16 slots={right} />
      </div>
    </div>
  );
}
